import * as React from 'react'
import { useTranslations } from 'next-intl'
import { tw } from 'utils/classnames'
import { CheckCircleIcon, CopyIcon } from 'primitives/icons'

export function SharePage({ inputValue }: { inputValue: string }) {
  const t = useTranslations()
  const [copied, setCopied] = React.useState(false)

  React.useEffect(() => {
    if (copied) {
      const timeout = setTimeout(() => {
        setCopied(false)
      }, 2000)

      return () => clearTimeout(timeout)
    }
  }, [copied])

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(inputValue)
      setCopied(true)
    } catch (error) {}
  }

  return (
    <div className="flex flex-row items-center gap-[10px] rounded-t-[12px] border border-[#DFDDE5] bg-[#F6F7FB] p-[10px]">
      <span className="w-[30%] flex-shrink-0 text-16 font-bold md:w-[35%]">
        {t('pages.tools.font_generator.share')}
      </span>
      <div className="relative flex w-full items-center ">
        <input
          className="h-[44px] w-full rounded border border-[#cfd7e0] bg-white p-[10px] pr-[100px] text-14 text-[#A399B8] focus:outline-none"
          type="text"
          value={inputValue}
          readOnly
        />
        <div
          onClick={handleCopy}
          className={tw(
            // oxlint-disable-next-line no-negated-condition
            !copied ? 'text-[#8559F9]' : 'text-secondary-500',
            'absolute inset-y-0 right-0 flex cursor-pointer items-center gap-[5px] pr-3 text-12 font-bold uppercase',
          )}
        >
          {!copied ? (
            <>
              <CopyIcon className="size-[18px]" />
              {t('components.copy_to_clipboard.button')}
            </>
          ) : (
            <>
              <CheckCircleIcon className="size-[18px] text-green-500" />
              <span>{t('components.copy_to_clipboard.copied')}</span>
            </>
          )}
        </div>
      </div>
    </div>
  )
}
